<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Delete Tax Trait
        </v-card-title>

        <v-card-text light>
          <p><strong>User ID</strong>: <code>{{ taxTraitUserId }}</code></p>
          <p><v-divider /></p>
          <p>Are you sure you want to delete the tax trait?</p>
          <p>This step can't be reverted.</p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            flat
            @click="() => { isVisible = false; $emit('submit') }"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeleteDialog',
  components: {
  },
  props: {
    visible: Boolean,
    taxTraitUserId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/taxTrait/DeleteDialog.vue